import { withInstall } from '../../utils';
import PageHeader from './src/page-header.vue';

export const IPageHeader = withInstall(PageHeader); // 增加类型

export default IPageHeader;
